import { ReactNode } from 'react';
import { LinkTrackingData } from '../../../../../AnalyticsContext/LinkTracking';
import { renderLinkTrackingAttributes } from '../../../../../AnalyticsContext/renderLinkTrackingAttributes';
import { Container, Descriptor, Visual } from './SuggestionTemplate.styles';

interface Props {
  visual: ReactNode;
  primary: ReactNode;
  secondary?: ReactNode;
  trackingData: LinkTrackingData;
}

export const SuggestionTemplate = ({ visual, primary, secondary, trackingData }: Props) => (
  <Container {...renderLinkTrackingAttributes(trackingData)}>
    <Visual>{visual}</Visual>
    <Descriptor>
      <div>{primary}</div>
      {secondary && <div>{secondary}</div>}
    </Descriptor>
  </Container>
);
